import React from "react";

export const SearchFormPopular: React.FC<InstantSearchResultsProps> = ({ popularTermArr }) => {
  popularTermArr.shift();
  return (
    <div className="thb-quick-search--popular">
      <div className="thb-quick-search--label fs-small uppercase">popular searches</div>
      {popularTermArr?.map((term) => (
        <a className="chip" href={`/search?q=${term}`}>
          {term}
        </a>
      ))}
    </div>
  );
};

interface InstantSearchResultsProps {
  popularTermArr: Array<string>;
}
